import { z } from "zod";

import { ALL_CALCULATIONS } from "~/tools/calculate-value-from-points";

import { DEFAULT as DEFAULT_SETTINGS, type Settings } from "../../../components/widget-form/gauge-chart/settings";
import { object, partial, tuple } from "../../_decoders";
import { Encoder } from "../../_encoder";
import { decoder as thresholdsModeDecoder, encoder as thresholdsModeEncoder } from "../thresholds/mode-spec";
import { decoder as thresholdsStepsDecoder, encoder as thresholdsStepsEncoder } from "../thresholds/steps-spec";

const decoder = object({
	0: z.string().optional().catch(undefined),
	1: z.number().optional().catch(undefined),
	2: z.number().optional().catch(undefined),
	3: z.enum(ALL_CALCULATIONS).optional().catch(undefined),
	4: z.string().optional().catch(undefined),

	5: tuple([thresholdsModeDecoder, thresholdsStepsDecoder])
		.transform(([mode, steps]) => partial({ mode, steps }))
		.optional()
		.catch(undefined),
})
	.transform((fields) =>
		partial<Settings>({
			unit: fields[0],
			decimals: fields[1],
			max: fields[2],
			calculation: fields[3],
			color: fields[4],
			thresholds: fields[5],
		}),
	)
	.catch(undefined);

function encoder({ unit, decimals, max, calculation, color, thresholds }: Settings): Encoder {
	return Encoder.shape({
		0: Encoder.primitive(unit, DEFAULT_SETTINGS.unit),
		1: Encoder.primitive(decimals, DEFAULT_SETTINGS.decimals),
		2: Encoder.primitive(max, DEFAULT_SETTINGS.max),
		3: Encoder.primitive(calculation, DEFAULT_SETTINGS.calculation),
		4: Encoder.primitive(color, DEFAULT_SETTINGS.color),
		5: Encoder.tuple(
			thresholdsModeEncoder(thresholds?.mode, DEFAULT_SETTINGS.thresholds.mode),
			thresholdsStepsEncoder(thresholds?.steps, DEFAULT_SETTINGS.thresholds.steps),
		),
	});
}

export { decoder, encoder };
